import { render, staticRenderFns } from "./ReclamationPreview.vue?vue&type=template&id=05e79492"
import script from "./ReclamationPreview.vue?vue&type=script&lang=js"
export * from "./ReclamationPreview.vue?vue&type=script&lang=js"
import style0 from "./ReclamationPreview.vue?vue&type=style&index=0&id=05e79492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports